import 'jquery-validation'; // https://jqueryvalidation.org/documentation/

/**
 * Extends the jquery-validation plugin to show the errors in the
 * right location in our theme
 */
export class FormValidator {

  constructor($form = null) {
    this.$form = $form;
    this.$errorContainer = $('.form-error-container');
    this.$errorTitle = this.$errorContainer.find('.form-error-container__title');
    this.$errorList = this.$errorContainer.find('.form-error-container__list');

    this.addValidationMethods();

    /** the validate function returns a Validator object
         *  store this in the check property so we can access
         *  this from other components
         */
    if ($form) {
      this.check = $form.validate({
        errorClass: 'error',
        rules: {
          'terms-of-service': 'required',
          'email': {
            emailaddress: true,
          },
          'suggested_by': {
            ifOneFilledBothRequired: '#suggested_by_email',
          },
          'suggested_by_email': {
            ifOneFilledBothRequired: '#suggested_by',
            emailaddress: true,
          },
          'profile_email': {
            emailaddress: true,
          },
          'mobile': {
            phone: true,
          },
          'profile_telefoon': {
            phone: true,
          },
          'profile_toevoeging': {
            maxlength: 10,
          },
          'profile_tussenvoegsel': {
            maxlength: 15,
          },
          'student_profile_email': {
            notEqualTo: '#profile_email',
            emailaddress: true,
          },
          'profile_mobile': {
            phone: true,
          },
          'student_profile_mobile': {
            phone: true,
          },
          'groep': {
            min: 1,
            max: 8,
          },
          'birthday': {
            dateFormat: true,
          },
        },
        errorElement: 'div',
        messages: {
          email: 'Het opgegeven e-mailadres is niet geldig',
          profile_email: 'Het opgegeven e-mailadres is niet geldig',
          suggested_by: {
            ifOneFilledBothRequired: 'Naam is een verplicht veld',
          },
          suggested_by_email: {
            ifOneFilledBothRequired: 'Het e-mailadres is een verplicht veld',
            email: 'Het opgegeven e-mailadres is niet geldig',
          },
          mobile: 'Het opgegeven telefoonnummer is niet geldig',
          profile_telefoon: 'Het opgegeven telefoonnummer is niet geldig',
          profile_mobile: 'Het opgegeven telefoonnummer is niet geldig',
          profile_tussenvoegsel: 'Het opgegeven tussenvoegsel is te lang (het maximum is 15 karakters).',
          student_profile_mobile: 'Het opgegeven telefoonnummer is niet geldig',
          student_profile_email: {
            notEqualTo: 'Het email-adres van ouder en leerling kan niet gelijk zijn',
            emailaddress: 'Het opgegeven e-mailadres is niet geldig',
          },
          birthday: {
            required: 'Het geboortedatum is verplicht',
            dateFormat: 'Het formaat van de geboortedatum moet DD/MM/YYYY zijn',
          },
        },
        errorPlacement: /* istanbul ignore next */ (error, element) => {
          this.errorPlacement(error, element);
        },
        invalidHandler: /* istanbul ignore next */ (event, validator) => {
          // istanbul ignore next
          this.onFormInvalid(event, validator);
        },
        submitHandler: /* istanbul ignore next */ (form) => {
          this.onFormSubmit(form);
        },
      });
    }
  }


  addValidationMethods() {
    /* istanbul ignore next */
    $.validator.addMethod(
      'ifOneFilledBothRequired',
      (value, element, param) => this.validateBothFilled(value, element, param),
      'Vul alstublieft een waarde in'
    );

    /* istanbul ignore next */
    $.validator.addMethod(
      'notEqualTo',
      (value, element, param) => this.validateNotEqual(value, element, param),
      'Vul alstublieft een andere waarde in'
    );

    /* istanbul ignore next */
    $.validator.addMethod(
      'emailaddress',
      email => this.validateEmailAddress(email),
      'Het opgegeven e-mailadres is niet geldig'
    );

    /* istanbul ignore next */
    $.validator.addMethod(
      'phone',
      number => this.validateDutchPhoneNumber(number),
      'Het opgegeven telefoonnummer is niet geldig'
    );

    /* istanbul ignore next */
    $.validator.addMethod(
      'zipcode',
      zipcode => this.validateDutchZipcode(zipcode),
      'De opgegeven postcode is niet geldig'
    );

    /* istanbul ignore next */
    $.validator.addMethod(
      'dateFormat',
      value => this.validateDateFormat(value),
      'Het opgegeven datumformaat is niet geldig'
    );
  }

  validateBothFilled(value, element, selector) {
    if ($(selector).val().length > 0) {
      return !!(value);
    }
    return true;
  }

  validateNotEqual(value, element, param) {
    return value != $(param).val();
  }

  validateEmailAddress(email) {
    if (email.length === 0) {
      return true;
    }
    const regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return regex.test(email);
  }

  validateDutchPhoneNumber(number) {
    if (number.length === 0) {
      return true;
    }
    const phone = /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/;
    const mobile = /^(((\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i;
    return (phone.test(number) || mobile.test(number));
  }

  validateDutchZipcode(zipcode) {
    const regex = /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/i;
    return regex.test(zipcode);
  }

  validateDateFormat(value) {
    if (!value) {
      return true;
    }

    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
    return regex.test(value);
  }

  onFormInvalid(e, validator) {
    this.$errorList.html('');
    $('html, body').animate({ scrollTop: this.$form.offset().top - 140 }, {
      duration: 500, queue: false,
    });

    let errors = validator.numberOfInvalids();
    if (errors) {
      if (errors == 1) {
        this.showError('Je hebt 1 veld niet of fout ingevuld, deze is beneden uitgelicht.');
      } else {
        this.showError(`Je hebt ${errors} velden niet of fout ingevuld, deze worden beneden uitgelicht.`);
      }
    } else {
      this.hideErrors();
    }
  }

  /**
     * Adds the list with specific error messages to the error notice
     * @param error
     */
  errorPlacement(error) {
    const $shownErrors = this.$errorList.find('li');
    const msg = $(error[0]).text();
    let errorStrings = [];

    // add already visible errors to errorString array
    for (let i = 0; i < $shownErrors.length; i++) {
      errorStrings.push($shownErrors.eq(i).text());
    }

    // ignore duplicate errors
    // invalidHandler already describes required fields so don't show this error
    if (errorStrings.indexOf(msg) === -1 && msg !== 'This field is required.') {
      errorStrings.push(msg);
      $(`<li>${msg}</li>`).appendTo(this.$errorList);
    }
  }

  onFormSubmit(form) {
    $('[type="submit"]').append('<i class="fa fa-spinner fa-spin" style="margin-left: 10px;"></i>');
    $('[type="submit"]').attr('disabled', 'true');
    form.submit();
  }

  showError(message) {
    this.$errorTitle.html(message);
    this.$errorContainer.show();
  }

  hideErrors() {
    this.$errorTitle.html('');
    this.$errorList.html('');
    this.$errorContainer.hide();
    this.$form.find('.js-invalid').removeClass('js-invalid');
  }
}
